import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { UploadOutput, UploadInput, UploaderOptions, UploadStatus } from '@angular-ex/uploader';
import { AppService } from '../../services/services';
import { ToastrService } from 'ngx-toastr';
import { Modal } from 'bootstrap';
import { GetExtensionPipe } from './get-extension.pipe';
import { DomSanitizer, EventManager } from "@angular/platform-browser";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EncryptionService } from "src/app/services/encryption.service";
import { ErrorModalComponent } from "../error-modal/error-modal.component";
import { ImageCroppedEvent, ImageCropperComponent } from "ngx-image-cropper";

@Component({
    selector: 'nri-app-img-upld',
    templateUrl: 'file-upload.component.html',
    styleUrls: ['file-upload.component.scss']
})

export class FileUploadComponent implements OnInit {
    @Input() imageName: any;
    @Input() docTypeID: any = '';
    url = '/upload';
    files: any;
    @Output() imageURL = new EventEmitter<any>();
    @Output() docTypeError = new EventEmitter<any>();
    @Output() getdocTypeID = new EventEmitter<any>();
    @Input() changeID: string | number;
    @Input() change: boolean = false;
    // maxpdfSize is an app-level setting that @angular-ex/uploader's own
    // UploaderOptions type does not declare, so it is widened here.
    options: UploaderOptions & { maxpdfSize?: number };
    uploadInput: EventEmitter<UploadInput>;
    image: any;
    showImg: boolean;
    erefNo: string;
    imgUploaded: boolean = false;
    imgName: string;
    public myModal: any;
    fileType: string = 'img';
    pdffile: any;
    bankStmt: boolean = false;
    getExtension: any;
    successMessage: any;
    statement: any;
    ocrType: string = "";
    @Output() getOcrDatas = new EventEmitter<any>();
    fatca: boolean = false;
    @Output() fatcaID = new EventEmitter<any>();
    @Input() taxID: string | number;
    @Input() getFatcaImage: boolean = false;
    @ViewChild('errorComp') errorComp: ErrorModalComponent;
    @Input() disableFileUpload = true;
    ocrResponse: any;
    @Input() additionalImageName: string = "";
    @Input() additionalImageName1: string = "";
    @ViewChild('imageCropper') imageCropper!: ImageCropperComponent;
    imgChangeEvt: any = "";
    cropImgPreview: any = "";
    cropperModal: any;
    @Input() disabled: boolean = false;
    digilockerupload: string = '';



    constructor(private loader: NgxUiLoaderService, public _http: AppService, private toastr: ToastrService, private sanitizer: DomSanitizer, private http: EncryptionService) {
        this.options = { concurrency: 1, maxUploads: 1, maxFileSize: 4194304, maxpdfSize: 4194304 };
        this.files = []; // local uploading files array
        this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader

        this.imgUploaded = false;
    }

    ngOnInit() {
        this.imgName = this.imageName;
        // this.fileType = 'img';
        this.fileType = 'both';
        this.bankStmt = false;
        if (this.imgName === 'Passport Front') {
            this.imgName = 'Passport1'
            this.fileType = 'both';
        }
        else if (this.imgName === 'Passport Back') {
            this.imgName = 'Passport2';
            this.fileType = 'both';
        } else if (this.imgName === 'OCI/PIO or Resident Permit/Visa Front') {
            this.imgName = 'PIOOCI'
        } else if (this.imgName === 'OCI/PIO or Resident Permit/Visa Back') {
            this.imgName = 'PIOOCIBACK'
        } else if (this.imgName === 'Foreign Address Front') {
            this.imgName = "ForeignAddr";
            this.fileType = 'both'
        }
        else if (this.imgName === 'Foreign Address Back') {
            this.imgName = "ForeignAddrBack";
            this.fileType = 'both'
        } else if (this.imgName === 'Permanent Address Front') {
            this.imgName = "PerAddr";
            this.fileType = 'both';
        } else if (this.imgName === 'Permanent Address Back') {
            this.imgName = "PerAddr1";
            this.fileType = 'both';
        }
        // else if(this.imgName === 'CDC Booklet'){
        //     this.imgName = "CDCBooklet";
        //     this.fileType = 'pdf';
        // }
        else if (this.imgName === 'VISA') {
            this.imgName = "VISA";
            this.fileType = 'both';
            this.docTypeID = 13;
        }
        else if (this.imgName === 'VISABACK') {
            this.imgName = "VISABACK";
            this.fileType = 'both';
            this.docTypeID = 13;
        }
        // else if(this.imageName === 'Offer Letter'){
        //     this.imgName = 'OfferLetter'
        //     this.fileType = 'pdf';
        // }
        else if (this.imageName === 'Income Proof') {
            this.imgName = "Income";
            this.fileType = 'both';
            this.docTypeID = 15;
        }
        else if (this.imageName === 'signature') {
            this.imgName = "signature";
            this.fileType = 'both';
        }
        else if (this.imageName === 'NRE' || this.imageName === 'NRO' || this.imageName === 'NRO_PIS' || this.imageName === 'NON_PIS') {
            this.fileType = 'both';
            this.bankStmt = true;
            if (this.imageName === 'NRE') {
                this.docTypeID = 21;
                this.statement = "your Bank Statement of latest 3 months";
            }
            if (this.imageName === 'NRO') {
                this.docTypeID = 20;
                this.statement = "your Bank Statement of latest 3 months"
            }
            if (this.imageName === 'NRO_PIS') {
                this.docTypeID = 22;
                this.statement = "your Bank Statement of latest 3 months"
            }
            if (this.imageName === 'NON_PIS') {
                this.docTypeID = 23;
                this.statement = "your Bank Statement of latest 3 months"
            }
        } else if (this.imageName === 'Immigration Stamp') {
            this.fileType = 'both'
            this.imgName = "Stamp";
        }
        else if (this.imageName === 'TaxImage1') {
            this.fileType = 'both'
            this.imgName = "TaxImage1";
            this.fatca = true;
        }
        else if (this.imageName === 'TaxImage2') {
            this.fileType = 'both'
            this.imgName = "TaxImage2";
            this.fatca = true;
        }
        else if (this.imageName === 'TaxImage3') {
            this.fileType = 'both'
            this.imgName = "TaxImage3";
            this.fatca = true;
        } else if (this.imageName === 'PIOOCIAdd') {
            this.fileType = 'both'
            this.imgName = "PIOOCIAdd";
        } else if (this.imageName === 'ForeignAddrAdd') {
            this.fileType = 'both'
            this.imgName = "ForeignAddrAdd";
        } else if (this.imageName === 'VISAAdd') {
            this.fileType = 'both'
            this.imgName = "VISAAdd";
        } else if (this.imageName === 'TaxImage1Add ') {
            this.fileType = 'both'
            this.imgName = "TaxImage1Add";
        } else if (this.imageName === 'TaxImage2Add ') {
            this.fileType = 'both'
            this.imgName = "TaxImage2Add";
        } else if (this.imageName === 'TaxImage3Add ') {
            this.fileType = 'both'
            this.imgName = "TaxImage3Add";
        } else if (this.imageName === 'AddImg1') {
            this.fileType = 'both'
            this.imgName = "AddImg1";
        } else if (this.imageName === 'AddImg2') {
            this.fileType = 'both'
            this.imgName = "AddImg2";
        } else if (this.imageName === 'AddImg3') {
            this.fileType = 'both'
            this.imgName = "AddImg3";
        }
        if (sessionStorage.getItem('digilocker')) {
            this.digilockerupload = sessionStorage.getItem('digilocker') || '';
        }
        this._http.getRefNum().subscribe(data => {
            this.erefNo = data;
            if (this.erefNo && !this.changeID) {
                this.getImages();
            }

        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["changeID"] && changes["changeID"].currentValue || changes["change"] && changes["change"].currentValue) {
            this.imgName = this.imgName ? this.imgName : changes['imageName'].currentValue;
            if (this.imgName === 'Foreign Address Front') {
                this.imgName = "ForeignAddr";
                this.fileType = 'both';
            }
            else if (this.imgName === 'Foreign Address Back') {
                this.imgName = "ForeignAddrBack";
                this.fileType = 'both';
            }
            else if (this.imgName === 'Permanent Address Front') {
                this.imgName = "PerAddr";
            }
            else if (this.imgName === 'Permanent Address Back') {
                this.imgName = "PerAddr1";
            }
            this.imageURL.emit({ url: "", name: this.imgName });
            this.image = "";
            this.showImg = false;
        }

        if (changes["getFatcaImage"] && changes["getFatcaImage"].currentValue) {
            this.imgName = this.imgName ? this.imgName : changes['imageName'].currentValue;
            this.getImages();
        }
    }

    getImages() {
        const checkSum = this.imgName + this.erefNo;
        const url = 'DIY/GetImagesByName';

        const params: GetParams = {
            'ReferenceNumber': this.erefNo ? this.erefNo : sessionStorage.getItem('AxNo'),
            'ImageName': this.imgName
        }
        if (this.taxID) {
            params.FatcaDetailsId = this.taxID ? this.taxID : '';
        }
        this.loader.start(this.imgName);
        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data: any) => {
                this.loader.stop(this.imgName);
                let imgData = this.http.decryptUsingAES256(data.OutPut);
                if (imgData && imgData.IsSuccess) {
                    if (imgData.Images[0].Image) {
                        this.image = 'data:image/jpeg;base64,' + imgData.Images[0].Image;
                        if (this.fileType === 'pdf') {
                            this.pdffile = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + imgData.Images[0].Image);
                        }
                        else if (this.fileType === 'both') {
                            let a = imgData.Images[0].ImagePath.split('.');
                            if (a[1] === 'pdf') {
                                this.pdffile = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + imgData.Images[0].Image);
                            }
                        }
                        this.showImg = true;
                    }
                    this.imageURL.emit({ url: this.image, name: this.imgName });
                    if (imgData.Images[0].DocumentTypeId) {
                        this.docTypeID = imgData.Images[0].DocumentTypeId;
                        if (!this.changeID) {
                            this.getdocTypeID.emit(this.docTypeID);
                        } else {
                            this.getdocTypeID.emit(this.changeID);
                            // this.imageURL.emit({url: "", name: this.imgName});
                            // this.image = "";
                            // this.showImg = false;
                        }

                    }
                }
            }, error: _error => {
                this.loader.stop(this.imgName);
                this.errorComp.ModalShow(_error.error.Message)
            }
        })
    }


    onUploadOutput(output: UploadOutput): void {
        // if(output.file){
        // if(output.type == "rejected"){
        //     this.errorComp.ModalShow("File size exceeds the maximum allowed (4MB)")
        //     return;
        // }
        // }
        let a: any = (output.file);
        let b: any = (this.options.maxFileSize);
        let c: any = document.getElementById(this.imageName);
        c.value = '';
        if ((this.imgName === 'PIOOCI' || this.imgName === 'PIOOCIBACK' || this.imgName === 'ForeignAddr' || this.imgName === 'ForeignAddrBack' || this.imgName === 'PerAddr' || this.imgName === 'PerAddr1' || this.imgName === 'VISA' || this.imgName === "VISABACK" || this.imgName === 'Income') && !this.docTypeID) {
            this.docTypeError.emit(true);
            this.uploadInput.emit({ type: 'removeAll' });
        } else {
            let getExtension = output.file ? GetExtensionPipe.prototype.transform(output.file.name) : '';
            if (getExtension) {
                this.getExtension = getExtension;
            }
            if (this.getExtension && this.getExtension.toLowerCase() === "pdf") {
                b = this.options.maxpdfSize;
            } else if (this.getExtension && this.getExtension.toLowerCase() !== "pdf") {
                b = this.options.maxFileSize;
            }
            if (((this.fileType === 'img' || this.fileType === 'both') && (this.getExtension.toLowerCase() === "png" || this.getExtension.toLowerCase() === "jpeg" || this.getExtension.toLowerCase() === "jpg")) || ((this.fileType === 'pdf' || this.fileType === 'both') && this.getExtension === 'pdf')) {
                if ((output.type === 'addedToQueue') && typeof output.file !== 'undefined' || (output.type === 'rejected') && typeof output.file !== 'undefined') {
                    this.files.push(output.file);
                    this.files = this.files.filter((file: any) => file.progress.status !== UploadStatus.Done);
                    let i = this.files.length - 1;
                    if (a && b < a.size) {
                        if (this.getExtension && this.getExtension.toLowerCase() === "pdf") {
                            this.errorComp.ModalShow('Maximum upload size: 4MB');
                        } else if (this.getExtension && this.getExtension.toLowerCase() !== "pdf") {
                            this.errorComp.ModalShow('Maximum upload size: 4MB');
                        }
                        this.uploadInput.emit({ type: 'removeAll' });
                    }
                    else if (this.files[i]) {
                        const reader = new FileReader();
                        if (this.fileType === 'img' || (this.fileType === 'both' && this.getExtension !== "pdf")) {
                            this.pdffile = '';
                            reader.readAsDataURL(this.files[i].nativeFile);
                            reader.onload = () => {
                                this.image = reader.result;
                                this.showImg = true;
                                let byteArray = this.convertDataURIToBinary(reader.result);
                                this.showImageCropper();

                            }
                        } else {
                            reader.readAsDataURL(this.files[i].nativeFile);
                            reader.onload = () => {
                                let pdfurl: any = reader.result;
                                // let preventPdf:any;
                                // let oldimag = this.image;
                                // if(this.pdffile){
                                //     preventPdf = this.pdffile.changingThisBreaksApplicationSecurity;
                                // }
                                // console.log(reader,"reader");
                                // console.log(this.files[i],"this.files[i]");

                                const base64Index = pdfurl.indexOf('base64,') + 'base64,'.length;
                                const base64String = pdfurl.substring(base64Index);
                                const binaryString = atob(base64String);
                                if (binaryString.includes('/Encrypt')) {
                                    this.getImages();
                                    this.errorComp.ModalShow('This PDF is password protected and cannot be uploaded.');
                                    return;
                                }
                                this.pdffile = this.sanitizer.bypassSecurityTrustResourceUrl(pdfurl);
                                let pageCount: any = 0;
                                pageCount = (binaryString.match(/\/Type\s*\/Page\b/g) || []).length;
                                if (pageCount === 0) {
                                    pageCount = (binaryString.match(/\/Type\b/g) || []).length;
                                }
                                // let a = pdfurl.split('base64,')
                                // let bin:any = atob(a[1]);
                                // let pageCount = bin.match(/\/Type\s*\/Page\b/g).length;
                                // if (this.imageName === 'CDC Booklet') {
                                //     if (pageCount > 5) {
                                //         this.errorComp.ModalShow('Max pages is 5')
                                //         this.uploadInput.emit({ type: 'removeAll' });
                                //     } else {
                                //         this.imgUpld();
                                //         this.showImg = true;
                                //         this.uploadInput.emit({ type: 'removeAll' });
                                //     }
                                // }
                                // else if (this.imageName === 'TaxImage1' || this.imageName === 'TaxImage2' || this.imageName === 'TaxImage3') {
                                //     if (pageCount > 5) {
                                //         this.errorComp.ModalShow('Max pages is 5')
                                //         this.uploadInput.emit({ type: 'removeAll' });
                                //     } else {
                                //         this.imgUpld();
                                //         this.showImg = true;
                                //         this.uploadInput.emit({ type: 'removeAll' });
                                //     }
                                // }
                                // else if (this.imageName === 'Immigration Stamp') {
                                //     if (pageCount > 1) {
                                //         this.errorComp.ModalShow('Max page is 1')
                                //         this.uploadInput.emit({ type: 'removeAll' });
                                //     } else {
                                //         this.imgUpld();
                                //         this.showImg = true;
                                //         this.uploadInput.emit({ type: 'removeAll' });
                                //     }
                                // }
                                // else if (this.imageName === 'Offer Letter') {
                                //     if (pageCount > 20) {
                                //         this.errorComp.ModalShow('Max pages is 20')
                                //         this.uploadInput.emit({ type: 'removeAll' });
                                //     } else {
                                //         this.imgUpld();
                                //         this.showImg = true;
                                //         this.uploadInput.emit({ type: 'removeAll' });
                                //     }
                                // }
                                // else if (this.imageName === 'Foreign Address Front' || this.imageName === 'Foreign Address Back') {
                                //     if ((this.docTypeID === '9' || this.docTypeID === '7') && pageCount > 50) {
                                //         this.errorComp.ModalShow('Max pages is 50')
                                //         this.uploadInput.emit({ type: 'removeAll' });
                                //     }
                                //     else if ((this.docTypeID !== '9' && this.docTypeID !== '7') && pageCount > 5) {
                                //         this.errorComp.ModalShow('Max pages is 5')
                                //         this.uploadInput.emit({ type: 'removeAll' });
                                //     }
                                //     else {
                                //         if (this.getExtension !== "pdf") {
                                //             this.imgUpld();
                                //         } else {
                                //             this.PdfUpload();
                                //         }
                                //         this.showImg = true;
                                //         this.uploadInput.emit({ type: 'removeAll' });
                                //     }
                                // }
                                // else if (this.imageName === 'Income Proof' || this.imageName === 'NRE' || this.imageName === 'NRO' || this.imageName === 'NRO_PIS' || this.imageName === 'NON_PIS') {
                                //     if (pageCount > 100) {
                                //         this.errorComp.ModalShow('Max pages is 100')
                                //         this.uploadInput.emit({ type: 'removeAll' });
                                //     } else {
                                //         this.imgUpld();
                                //         this.showImg = true;
                                //         this.uploadInput.emit({ type: 'removeAll' });
                                //     }
                                // }
                                // else {
                                if (this.imageName === 'NRO' || this.imageName === 'NRO_PIS' || this.imageName === 'NON_PIS') {
                                    this.imgUpld();
                                    this.showImg = true;
                                    this.uploadInput.emit({ type: 'removeAll' });
                                } else {
                                    if (pageCount > 1) {
                                        this.errorComp.ModalShow('Max page is 1')
                                        this.uploadInput.emit({ type: 'removeAll' });
                                        // this.image ='';
                                        this.pdffile = null;
                                        this.files = [];
                                        //  this.pdffile.changingThisBreaksApplicationSecurity = '';
                                        //  this.fileType= 'both';
                                        //  if(!this.image){
                                        //     this.showImg = false;
                                        //  }

                                    } else {
                                        if (this.getExtension !== "pdf") {
                                            this.imgUpld();
                                        } else {
                                             if (this.docTypeID === 11 || this.docTypeID === "11") {
                                                    this.ocrType = "ind_aadhaar";
                                                } else if (this.imgName === "PAN") {
                                                    this.ocrType = "ind_pan";
                                                } else if (this.docTypeID === 10 || this.docTypeID === "10") {
                                                    this.ocrType = "ind_driving_license";
                                                } else if (this.docTypeID === 12 || this.docTypeID === "12") {
                                                    this.ocrType = "ind_voter_id";
                                                } else if (this.imgName === "Passport1" || this.imgName === "Passport2") {
                                                    this.ocrType = "ind_passport";
                                                }
                                            if (this.imgName === "PAN") {
                                                this.ocrPDFPan()
                                            } else {
                                                this.PdfUpload();
                                            }
                                        }
                                        this.showImg = true;
                                        this.uploadInput.emit({ type: 'removeAll' });
                                    }
                                }



                                // }
                            }
                        }
                    }
                }
            } else {
                if ((output.type) && typeof output.file !== 'undefined') {
                    if (this.fileType === 'img') {
                        this.errorComp.ModalShow("Only png, jpeg , jpg & pdf file allowed");
                        this.uploadInput.emit({ type: 'removeAll' });
                    }
                    else if (this.fileType === 'both') {
                        this.errorComp.ModalShow("Only png, jpeg, jpg & pdf file allowed");
                        this.uploadInput.emit({ type: 'removeAll' });
                    }
                    else {
                        this.errorComp.ModalShow("Only pdf file allowed");
                        this.uploadInput.emit({ type: 'removeAll' });
                    }
                } else {
                    this.uploadInput.emit({ type: 'removeAll' });
                }
            }
        }
    }

    convertDataURIToBinary(dataURI: any) {
        var base64Index = dataURI.indexOf(';base64,') + ';base64,'.length;
        var base64 = dataURI.substring(base64Index);
        var raw = window.atob(base64);
        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));

        for (let i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
        }
        return array;
    }

    aadharMasking() {
        const checkSum = this.imgName + this.erefNo;
        const params = {
            "ImageName": this.imgName,
            "ReferenceNumber": this.erefNo,
            "DocumentType": this.docTypeID,
            "Image": this.getExtension === 'pdf' ? this.pdffile.changingThisBreaksApplicationSecurity : this.image,
            "Extention": this.getExtension
        }
        const path = 'DIY/AadharMasking';
        this.loader.start();
        this._http.httpPost(path, params, checkSum).subscribe({
            next: (data: any) => {
                this.loader.stop();
                let decryptAadharResponse = this.http.decryptUsingAES256(data.OutPut);
                console.log(decryptAadharResponse);
                if (decryptAadharResponse.IsSuccess) {
                    // this.ocrReading(decryptAadharResponse.ImageBase64)
                    this.imgUpld(decryptAadharResponse.ImageBase64);
                } else {
                    this.image = "";
                    this.showImg = false;
                    this.imageURL.emit({ url: this.image, name: this.imgName });
                    this.errorComp.ModalShow(decryptAadharResponse.ErrorMessage);
                }

            }, error: (e: any) => {
                this.errorComp.ModalShow(e.error.Message);
            }
        }
        )


    }

    ocrReading() {
        const checkSum = this.imgName + this.erefNo;
        const params = {
            "ImageName": this.imgName,
            "ReferenceNumber": this.erefNo,
            "DocumentType": this.docTypeID,
            "Image": this.getExtension === 'pdf' ? this.pdffile.changingThisBreaksApplicationSecurity : this.image,
            "Extention": this.getExtension,
            "OCRType": this.ocrType
        }
        const path = 'DIY/DocumentOCR';
        this.loader.start();
        this._http.httpPost(path, params, checkSum).subscribe({
            next: (data: any) => {
                this.loader.stop();
                let decryptAadharResponse = this.http.decryptUsingAES256(data.OutPut);
                console.log(decryptAadharResponse);
                if (decryptAadharResponse && decryptAadharResponse.IsSuccess) {
                    // this.fileType = 'img';
                    this.getOcrDatas.emit({ data: decryptAadharResponse['Bindingdata'] });
                    if (this.docTypeID === 11 || this.docTypeID === "11") {
                        this.aadharMasking();
                    } else {
                        this.imgUpld(decryptAadharResponse.ImageBase64);
                    }
                } else {
                    this.image = "";
                    this.showImg = false;
                    this.pdffile = null
                    this.imageURL.emit({ url: this.image, name: this.imgName });
                    this.errorComp.ModalShow(decryptAadharResponse.ErrorMessage || "OCR Reading Failed");
                }

            }, error: (e: any) => {
                this.errorComp.ModalShow(e.error.Message);
            }
        }
        )


    }

    PdfUpload(baseImg?: any) {
        const checkSum = this.imgName + this.erefNo;
        let params: ImageUploadParams = {
            "ImageName": this.imgName,
            "ReferenceNumber": this.erefNo,
            "DocumentType": this.docTypeID,
            "Image": ((this.docTypeID === 11 || this.docTypeID === "11") && this.getExtension !== "pdf") ? baseImg : this.getExtension === 'pdf' ? this.pdffile.changingThisBreaksApplicationSecurity : this.image,
            "Extention": this.getExtension
        }
        if (this.taxID) {
            params.FatcaDetailsId = this.taxID ? this.taxID : '';
        }
        const path = 'DIY/DIYPDFUpload';
        this.loader.start(this.imgName);
        this._http.httpPost(path, params, checkSum).subscribe({
            next: (data: any) => {
                let fileUploadVal = this.http.decryptUsingAES256(data.OutPut)
                this.loader.stop(this.imgName);

                if (fileUploadVal.IsSuccess) {
                    this.successMessage = fileUploadVal.Success;
                    this.image = fileUploadVal.Image
                    this.getExtension = fileUploadVal.Extention
                    console.log(this.successMessage);
                    if (this.imgName === "PerAddr" || this.imgName === "PerAddr1" || this.imgName === "Passport1" || this.imgName === "Passport2" || this.imgName === "ind_voter_id") {
                        this.ocrReading();
                    } else {
                        this.imgUpld();
                    }

                    // this.toastr.success(this.successMessage);
                } else {
                    this.errorComp.ModalShow("File upload failed. Please try again later.");
                    this.imageURL.emit({ url: "", name: this.imgName });
                    this.image = "";
                    this.showImg = false;
                }
            },
            error: (_error: any) => {
                this.loader.stop(this.imgName);
                this.errorComp.ModalShow(_error.error.Message);
                this.imageURL.emit({ url: "", name: this.imgName });
                this.image = "";
                this.showImg = false;
            }
        })
    }
    imgUpld(baseImg?: any) {
        if (!this.imgUploaded) {
            const checkSum = this.imgName + this.erefNo;
            let params: ImageUploadParams = {
                "ImageName": this.imgName,
                "ReferenceNumber": this.erefNo,
                "DocumentType": this.docTypeID,
                "Image": this.getExtension === 'pdf' ? this.pdffile.changingThisBreaksApplicationSecurity : this.image,
                // "Image": ((this.docTypeID === 11 || this.docTypeID === "11") && this.getExtension !== "pdf") ? baseImg : this.image,
                "Extention": this.getExtension
            }
            if (this.taxID) {
                params.FatcaDetailsId = this.taxID ? this.taxID : '';
            }
            const path = 'DIY/DIYImageUpload';
            this.loader.start(this.imgName);
            this._http.httpPost(path, params, checkSum).subscribe({
                next: (data: any) => {
                    let fileUploadVal = this.http.decryptUsingAES256(data.OutPut)
                    this.loader.stop(this.imgName);
                    if (fileUploadVal.IsSuccess && !fileUploadVal.ImageUploadSuccess) {
                        this.successMessage = fileUploadVal.Success;
                        this.toastr.info(this.successMessage);
                        this.getImages();
                        return;
                    }
                    if (fileUploadVal.IsSuccess) {
                        this.successMessage = fileUploadVal.Success;
                        console.log(this.successMessage);
                        this.getformData();
                         if (this.imageName === 'NRO' || this.imageName === 'NRO_PIS' || this.imageName === 'NON_PIS') {
                         }else{
                            // this.fileType = 'img';
                            this.pdffile = null;
                         }
                        // this.toastr.success(this.successMessage);
                        if (this.fatca) {
                            this.fatcaID.emit({ id: fileUploadVal.FatcaDetailsId, name: this.imgName });
                        }
                        if (this.getExtension === 'pdf') {
                            this.imageURL.emit({ url: this.pdffile.changingThisBreaksApplicationSecurity, name: this.imgName });
                        } else {
                            if (this.docTypeID === 11 || this.docTypeID === "11") {
                                this.getImages();
                            }
                            this.imageURL.emit({ url: this.image, name: this.imgName });
                        }
                    } else {
                        this.errorComp.ModalShow("File upload failed. Please try again later.");
                        this.imageURL.emit({ url: "", name: this.imgName });
                        this.image = "";
                        this.showImg = false;
                    }
                },
                error: (_error: any) => {
                    this.loader.stop(this.imgName);
                    this.errorComp.ModalShow(_error.error.Message);
                    this.imageURL.emit({ url: "", name: this.imgName });
                    this.image = "";
                    this.showImg = false;
                }
            })

        }
    }

    imgModal() {
        const element = document.getElementById('myModal' + this.imageName) as HTMLElement;
        this.myModal = new Modal(element, { backdrop: 'static', keyboard: false });
        this.myModal.show();
    }
    removeFile(id: string): void {
        this.uploadInput.emit({ type: 'remove', id: id });
    }

    ocrPDFPan() {
        const checkSum = this.imgName + this.erefNo;
        const params = {
            "ImageName": this.imgName,
            "ReferenceNumber": this.erefNo,
            "DocumentType": this.docTypeID,
            "Image": this.getExtension === 'pdf' ? this.pdffile.changingThisBreaksApplicationSecurity : this.image,
            "Extention": this.getExtension,
            "OCRType": "ind_pan"
        }
        const path = 'DIY/DIYPanPDFUpload';
        this.loader.start(this.imgName);
        this._http.httpPost(path, params, checkSum).subscribe({
            next: (data: any) => {
                this.loader.stop(this.imgName);
                let decryptocrRes = this.http.decryptUsingAES256(data.OutPut);
                console.log(decryptocrRes);
                if (decryptocrRes && decryptocrRes.IsSuccess) {
                    this.image = decryptocrRes.Image;
                    //  this.fileType = 'img';
                    this.getExtension = decryptocrRes.Extention
                    console.log(this.successMessage);
                    this.ocrForPan();
                } else {
                    this.image = "";
                    this.pdffile = null;
                    this.showImg = false;
                    this.imageURL.emit({ url: this.image, name: this.imgName });
                    this.errorComp.ModalShow(decryptocrRes.ErrorMessage || "OCR Reading Failed");
                }

            }, error: (e: any) => {
                this.loader.stop();
                this.errorComp.ModalShow(e.error.Message);
            }
        }
        )
    }
    ocrForPan() {
        const checkSum = this.imgName + this.erefNo;
        const params = {
            "ImageName": this.imgName,
            "ReferenceNumber": this.erefNo,
            "DocumentType": this.docTypeID,
            "Image": this.getExtension === 'pdf' ? this.pdffile.changingThisBreaksApplicationSecurity : this.image,
            "Extention": this.getExtension,
            "OCRType": this.ocrType ? this.ocrType : "ind_pan"
        }
        const path = 'DIY/PanDocumentOCR';
        this.loader.start(this.imgName);
        this._http.httpPost(path, params, checkSum).subscribe({
            next: (data: any) => {
                this.loader.stop(this.imgName);
                let decryptocrRes = this.http.decryptUsingAES256(data.OutPut);
                console.log(decryptocrRes);
                if (decryptocrRes && decryptocrRes.IsSuccess) {
                    // this.fileType = 'img';
                     this.pdffile = null;
                    this.ocrResponse = decryptocrRes['Bindingdata'];
                    // this.getOcrDatas.emit({data: this.ocrResponse});
                    this.panImageUpload(decryptocrRes.Image, decryptocrRes['Bindingdata'].BindingdataFront.IdNumber);
                } else {
                    this.image = "";
                    this.pdffile = null;
                    this.showImg = false;
                    this.imageURL.emit({ url: this.image, name: this.imgName });
                    this.errorComp.ModalShow(decryptocrRes.ErrorMessage || "OCR Reading Failed");
                }

            }, error: (e: any) => {
                this.loader.stop(this.imgName);
                this.loader.stop();
                this.errorComp.ModalShow(e.error.Message);
            }
        }
        )
    }
    panImageUpload(baseImg: string, pan: string) {
        const checkSum = this.imgName + this.erefNo;
        let params = {
            "ImageName": this.imgName,
            "ReferenceNumber": this.erefNo,
            "DocumentType": this.docTypeID,
            "Image": baseImg,
            "Extention": this.getExtension,
            "PanNumber": pan
        }
        const path = 'DIY/DIYPanImageUpload';
        this.loader.start(this.imgName);
        this._http.httpPost(path, params, checkSum).subscribe({
            next: (data: any) => {
                let fileUploadVal = this.http.decryptUsingAES256(data.OutPut);
                this.loader.stop(this.imgName);
                if (fileUploadVal?.IsSuccess) {
                    this.successMessage = fileUploadVal.Success;
                    console.log(this.successMessage);
                    this.getformData(pan);
                    // this.toastr.success(this.successMessage);
                    if (this.ocrResponse) {
                        this.getOcrDatas.emit({ data: this.ocrResponse, success: fileUploadVal.IsSuccess });
                    }
                    this.imageURL.emit({ url: this.image, name: this.imgName });
                } else {
                    this.getOcrDatas.emit({ data: "", success: false });
                    this.errorComp.ModalShow("File upload failed. Please try again later.");
                    this.imageURL.emit({ url: "", name: this.imgName });
                    this.image = "";
                    this.showImg = false;
                }
            },
            error: (_error: any) => {
                this.loader.stop(this.imgName);
                this.errorComp.ModalShow(_error.error.Message);
                this.imageURL.emit({ url: "", name: this.imgName });
                this.image = "";
                this.showImg = false;
            }
        })
    }

    getformData(pan?: string) {
        let formdata = new FormData();
        let i = this.files.length - 1;
        formdata.append("ReferenceNumber", this.erefNo);
        formdata.append("DocumentType", this.docTypeID);
        formdata.append("ImageName", this.imgName);
        formdata.append("Image", this.files[i]['nativeFile']);
        formdata.append('Extention', this.getExtension);
        if (pan) {
            formdata.append('PanNumber', pan);
        }
        this.loader.start(this.imgName);
        const path = 'DIY/UploadFormData'
        this._http.httpPostForm(path, formdata).subscribe({
            next: (data: any) => {
                this.loader.stop(this.imgName);
                console.log(data, 'data');

            }, error: e => {
                this.loader.stop(this.imgName);
            }
        })

    }

    onFileChange(event: any): void {
        this.imgChangeEvt = event;
    }
    cropImg(e: ImageCroppedEvent) {
        this.image = e.base64;
    }

    imgLoad() {
        // display cropper tool
    }

    initCropper() {
        // init cropper
        // this.imgChangeEvt = this.image;
    }

    imgFailed() {
        // error msg
    }

    showImageCropper() {
        const id: any = document.getElementById(`imagecropper${this.imageName}`);
        this.cropperModal = new Modal(id, { backdrop: 'static', keyboard: false });
        this.cropperModal.show();
    }

    croppedImageupload() {
        if (this.docTypeID === 11 || this.docTypeID === "11") {
            this.ocrType = "ind_aadhaar";
            if (this.getExtension === 'pdf') {
                this.PdfUpload()
            } else {
                this.ocrReading();
            }

        } else if (this.imgName === "PAN") {
            this.ocrType = "ind_pan";
            if (this.getExtension === 'pdf') {
                this.ocrPDFPan()
            } else {
                this.ocrForPan();
            }
            // this.ocrForPan();
        } else if (this.docTypeID === 10 || this.docTypeID === "10") {
            this.ocrType = "ind_driving_license";
            if (this.getExtension === 'pdf') {
                this.PdfUpload()
            } else {
                this.ocrReading();
            }
        } else if (this.docTypeID === 12 || this.docTypeID === "12") {
            this.ocrType = "ind_voter_id";
            if (this.getExtension === 'pdf') {
                this.PdfUpload()
            } else {
                this.ocrReading();
            }
        } else if (this.imgName === "Passport1" || this.imgName === "Passport2") {
            this.ocrType = "ind_passport";
            if (this.getExtension === 'pdf') {
                this.PdfUpload()
            } else {
                this.ocrReading();
            }
        } else {
            this.imgUpld();
        }
        this.uploadInput.emit({ type: 'removeAll' });
    }
}


export interface ImageUploadParams {
    ImageName: string;
    ReferenceNumber: string
    DocumentType: number | string;
    Image: string;
    Extention: string;
    FatcaDetailsId?: string | number;
}

export interface GetParams {
    ReferenceNumber: string | null;
    FatcaDetailsId?: string | number;
    ImageName: string;
}